<div
  modalEscape
  (escape)="close.emit()"
  class="content rv-rows"
  [style.min-width]="minWidth"
>
  <div class="rv-flex top-modal-header">
    <h5 class="rv-title-02">{{ title }}</h5>
    <button
      rivButton
      [variant]="'ghost'"
      [size]="'large'"
      class="close"
      title="Close"
      [rivTooltip]="'Close'"
      type="button"
      (click)="$event.preventDefault(); close.emit()"
      [icon]="'X'"
    ></button>
  </div>
  <ng-content></ng-content>
</div>
